const catchUpStorageKey = "story-feed:catch-up-seen:v1";
export function browserCatchUpSessionStore() {
    if (typeof window === "undefined") {
        return null;
    }
    try {
        return window.sessionStorage;
    }
    catch {
        return null;
    }
}
function visitId(gameId, checkpoint) {
    return `${gameId}:${checkpoint}`;
}
function readSeenVisits(store) {
    try {
        const stored = store.getItem(catchUpStorageKey);
        if (!stored) {
            return new Set();
        }
        const parsed = JSON.parse(stored);
        if (!Array.isArray(parsed)) {
            return new Set();
        }
        return new Set(parsed.filter((value) => typeof value === "string"));
    }
    catch {
        return new Set();
    }
}
/**
 * Returns true only for the first external entry to this game/checkpoint in the
 * current browser-tab session. If browser storage is unavailable, the demo
 * degrades to showing Catch Up rather than suppressing useful context.
 */
export function claimCatchUpVisit(store, gameId, checkpoint) {
    const seenVisits = readSeenVisits(store);
    const id = visitId(gameId, checkpoint);
    if (seenVisits.has(id)) {
        return false;
    }
    seenVisits.add(id);
    try {
        store.setItem(catchUpStorageKey, JSON.stringify([...seenVisits]));
    }
    catch {
        return true;
    }
    return true;
}
export function resetCatchUpVisits(store) {
    try {
        store.removeItem(catchUpStorageKey);
    }
    catch {
        // A storage-disabled browser already behaves like a fresh demo session.
    }
}
